/** The booking question a reschedule asks of a booked Visit, worded once for the single and the bulk dialog. */
import { VisitBookingChoice } from '../visit.movement.types';

/** One picker option for `VisitBookingChoice`. */
export interface VisitBookingOption {
  value: VisitBookingChoice;
  label: string;
}

/** "Keep crew & move booking" / "Release booking"; `plural` words them for a selection of Visits. */
export function visitBookingOptions(plural: boolean): VisitBookingOption[] {

  const booking = plural ? 'bookings' : 'booking';
  return [
    { value: VisitBookingChoice.Keep, label: `Keep crew & move ${booking}` },
    { value: VisitBookingChoice.Release, label: `Release ${booking}` },
  ];
}
